/* Validation Errors */
const errorText = {
    confirmOwnerText: 'Du må bekrefte',
    respondQuestion: 'Du må svare på spørsmålet',
    orgnrLength: 'Organisasjonsnummer må ha 9 siffer',
    emailMissing: 'Du må oppgi en e-postadresse',
    emailInvalid: 'Du må oppgi en e-postadresse med gyldig format',
    mobileLength: 'Mobilnummeret må ha 8 siffer',
    name: 'Du må oppgi minst ett fornavn og ett etternavn',
    ssn: 'Fødselsnummer må ha 11 siffer',

    // Length Validation
    ssnLengthVal: 11,
    mobileLengthVal: 8,

    // Feedback
    feedbackMessageRequired: 'Du må fylle ut tilbakemelding.',
    feedbackMessageMax: 'Du kan maks bruke 500 tegn.',
};

/* NAF Login */
const errorTextNaf = {
    invalidField: 'Ugyldig verdi i felt',
    mobileLength: 'Mobilnummer må være 8 siffer',
    mobileRequired: 'Mobilnummer kan ikke være tomt felt',
    memberNoRequired: 'Medlemsnummer kan ikke være tomt felt',
    memberNoLength: 'Medlemsnummer må være 7 eller 8 siffer',
    birthdateLength: 'Fødselsdato må være 8 siffer',
    birthdateRequired: 'Fødselsdato kan ikke være tomt felt',
    birthdateFormat: 'Angitt verdi er ikke en gyldig fødselsdato',
    birthdateLimit: 'Du må være minst 25 år for å søke dette lånet',
};

export { errorText, errorTextNaf };
